module.exports = __webpack_public_path__ + "img/img 4.5438d3a4.png";